import Router from 'next/router';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'utils/with-i18next';
import Logo from '../../assets/img/Logo';
import BASIC_CONSTANT from '../../constants/basic.constants.js/basic.constants.js';
import URL_CONSTANT from '../../constants/url.constants.js';
import UserActions from '../../redux/UserActions';
import SelectLanguages from './SelectLanguages';
import { HamburgerButton, HeaderTitle, LoginLink, MobileNav, Nav, UserMenu } from './components';
import useHeaderState from './useHeaderState';

function Header({ t, UserRedux, logout: dispatchLogout }) {
  const { isOn, toggleIsOn, pathData } = useHeaderState(UserRedux.user);
  const logout = () => {
    localStorage.removeItem(BASIC_CONSTANT.USER_TOKEN_KEY);
    dispatchLogout();
    Router.push(URL_CONSTANT.home.url);
  };
  const isLoggedIn = UserRedux.user?.name;
  const showNav = pathData && !pathData.title && !pathData.channelDetail;

  return (
    <>
      <header className="fixed top-0 left-0 w-full px-[5%] z-[1000] bg-background">
        <div className="flex items-center justify-between py-4">
          <a id="logo-tt" className="font-bold" href="/">
            <Logo />
          </a>
          {showNav && <Nav t={t} pathData={pathData} />}
          {isLoggedIn ? (
            <div className="flex items-center gap-4">
              <HeaderTitle pathData={pathData} channelUser={UserRedux.channelUser} />
              <SelectLanguages t={t} />
              <UserMenu user={UserRedux} pathData={pathData} onLogout={logout} t={t} />
            </div>
          ) : (
            <div className="flex items-center gap-4">
              <LoginLink pathData={pathData} t={t} />
              <HamburgerButton isOpen={isOn} onToggle={() => toggleIsOn(!isOn)} />
            </div>
          )}
        </div>
        {!isLoggedIn && <MobileNav isOpen={isOn} t={t} />}
      </header>
    </>
  );
}

Header.propTypes = { t: PropTypes.func };
export default connect(
  state => state,
  (dispatch, ownProps) => ({ ...UserActions(dispatch, ownProps) })
)(withTranslation('common')(Header));
